import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';

const propType = {
  _id: PropTypes.string,
  updatedAt: PropTypes.number,
  createdAt: PropTypes.number,
  sponsor: PropTypes.string,
  type: PropTypes.string,
  isForecast: PropTypes.bool,
  description: PropTypes.string,
  sale: {
    _id: PropTypes.string,
    saleId: PropTypes.string,
    metadata: {
      ownerEmail: PropTypes.string,
      numberOfLots: PropTypes.number,
      propertyManagerId: PropTypes.string,
      agencyClass: PropTypes.string,
    },
    date: PropTypes.string,
    status: PropTypes.string,
    amount: PropTypes.number,
    skillLevel: PropTypes.number,
  },
  game: PropTypes.string,
  origin: PropTypes.string,
  date: PropTypes.number,
  paymentDate: PropTypes.number,
  metadata: PropTypes.shape({}),
  currency: PropTypes.string,
  percentage: PropTypes.number,
  VA: PropTypes.number,
  commissionVA: PropTypes.number,
  commission: PropTypes.number,
  amountWithVAT: PropTypes.number,
  amount: PropTypes.number,
  marketProduct: PropTypes.string,
  marketOrder: PropTypes.string,
  iteration: PropTypes.number,
  userLevel: PropTypes.number,
  user: PropTypes.shape(UserProp.propType),
  sourceUserLevel: PropTypes.number,
  sourceUser: PropTypes.shape(UserProp.propType),
  sponsorLevel: PropTypes.number,
};

export const SALE_STATUS = {
  ON_GOING: 'on_going',
  RECEIVED: 'received',
  PAID: 'paid',
  CANCELED: 'canceled',
  DISABLED: 'disabled',
  REJECTED: 'rejected',
};

export default { propType };
